import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a6750c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "board-confirmation-container" }
const _hoisted_2 = {
  ref: "contentArea",
  class: "content-area board-history"
}
const _hoisted_3 = { class: "board-confirmation-info" }
const _hoisted_4 = {
  key: 0,
  class: "service-evaluation-wrapper"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider top" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode($setup["NavigationBar"], {
        shouldHideBackButton: true,
        shouldShowUnderline: true,
        title: "상세내역",
        onOnClickClose: $setup.emitOnClickClose
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("section", _hoisted_3, [
          _createVNode($setup["BoardHistoryDetailInfo"], {
            boardInfo: $props.boardInfo,
            onOnClickBusStopLocation: $setup.onClickBusStopLocation
          }, null, 8 /* PROPS */, ["boardInfo"])
        ]),
        ($setup.lineSurvey)
          ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
              _hoisted_5,
              _createVNode($setup["ServiceEvaluationQuestions"], {
                ref: "serviceEvaluationQuestions",
                lineSurvey: $setup.lineSurvey
              }, null, 8 /* PROPS */, ["lineSurvey"])
            ]))
          : _createCommentVNode("v-if", true)
      ], 512 /* NEED_PATCH */),
      ($setup.lineSurvey)
        ? (_openBlock(), _createBlock($setup["FooterButton"], {
            key: 0,
            class: "btn-footer",
            title: "평가완료",
            onOnClickFooterButton: $setup.responseServiceEvaluation,
            disabled: !$setup.isEvaluable
          }, null, 8 /* PROPS */, ["disabled"]))
        : _createCommentVNode("v-if", true),
      ($setup.contentArea)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 1,
            class: "scroll-top-wrapper",
            container: $setup.contentArea
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode($setup["PageModal"], {
      shouldShow: $setup.shouldShowMap,
      onBackHandler: () => $setup.toggleShowMap(false)
    }, {
      default: _withCtx(() => [
        _createVNode($setup["MapOfBusStop"], {
          class: "map",
          targetBusStop: $setup.selectedBusStop,
          onOnClickClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowMap(false)))
        }, null, 8 /* PROPS */, ["targetBusStop"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
  ], 64 /* STABLE_FRAGMENT */))
}